/**
 * React Query keys for the organization-service sales metro reads.
 *
 * `list` is the one invalidation surface: a saved admin assignment refreshes
 * it, and the table's rows come only from it. The zip lookup contributes a
 * metro id to the search and nothing else, so it never goes stale behind a
 * save.
 */
export const salesMetrosKeys = {
  /** The whole list, Unassigned included, as the Sales Metros page manages it. */
  list: () => ['sales-metros', 'list'],
  zips: (salesMetroId) => ['sales-metros', 'zips', salesMetroId],
  byZip: (zip) => ['sales-metros', 'by-zip', zip],
};
